import { INDEX_INTRADAY_AVAILABLE } from '@/features/market/api/marketService'
import type { ValueHistoryPeriod } from '@/schemas/portfolio'
import type { IndexRange } from '@/schemas/market'

/**
 * What Home's cards open on, in a module the route loader can import.
 *
 * The loader starts these reads before the page mounts, so it has to ask for
 * the same keys the cards will — and it cannot import the card modules to
 * find out: route loaders are not code-split, so a card imported here would
 * ship in the entry chunk. The cards read their first state from here too, so
 * the two cannot drift apart.
 */

/** PortfolioCard's value curve, before a member picks a period. */
export const HOME_VALUE_FIRST_PERIOD = '1m' satisfies ValueHistoryPeriod

/**
 * IndexTodayCard's chart, before a member picks a range: 1D while mm-be serves the intraday series,
 * 1W otherwise (owner ruling 2, 2026-10-28). It follows `INDEX_INTRADAY_AVAILABLE`, so the one
 * constant that turns the 1D chart on also makes it the default.
 */
export const HOME_INDEX_DEFAULT_RANGE: IndexRange = INDEX_INTRADAY_AVAILABLE ? '1d' : '1w'
